// permission ENUM to validate Authorized navigation
export const userPermissions = {
  LIST_PROGRAM: 'lst:prog', //permission to view Programs table
  LIST_POLICY: 'lst:pol', //permission to view Policy table
  LIST_ADMINISTRATION: 'lst:adm', // only for admin users to access administration pages

  READ_REPORT: 'rd:rpt', // permission to view Reports tab in Navbar and program's report tab
  READ_ALL: 'rd:all', // only for admin users
  READ_PROGRAMTABS: 'rd:progtabs', // if user has this permission then he can see all program tabs(Draft, Pending Approval, UW Approved, Approved. Client users don't have this permission so they can only see "Approved" tab and can't see/perform any program actions e.g. Endorse, Renew, Copy, Cancel etc. )

  MANAGE_BILL: 'mng:bill', // permission to view Master bills for Arch admin
  MANAGE_SPA: 'mng:spa',
  MANAGE_SETTODRAFT: 'mng:setdraft', // only visible for Client(Policy reinsurance tab)
  MANAGE_PROGRAMUSER: 'mng:progusr', // permission to edit/delete program users for Arch admin
  MANAGE_PROGRAM: 'mng:prog', // permission to access Program's General info, Contractual info, Characteristics & Layers tab for Arch admin
  MANAGE_REFERRAL_AUTHORIZATION: 'mng:progrfr',

  WRITE_PROGRAM: 'wrt:prog', // add/edit programs for Arch admin
  WRITE_POLICY: 'wrt:pol', //add/edit policy for arch and client users

  MANAGE_BDX: 'mng:bdx',
  LIST_TOOLS: 'lst:tools', //List/view tools tab
  WRITE_DOC: 'wrt:doc', // write docs
};
